exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".my-custom-scrollbar {\n    position: relative;\n    height: 400px;\n    overflow: auto;\n}\n.table-wrapper-scroll-y {\n    display: block;\n}\n\n.fullscreen {\n    width: 100vw;\n    height: 90vh;\n    position: fixed;\n    top: 75px;\n    left: 0;\n    z-index: 200;\n    background-color: white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/tour-form/tour-form.component.css
// module id = 451
// module chunks = 0